import { isNumber, clamp } from 'lodash';

/**
 * @param {Any} val
 * @returns {Number}
 */
const parsePositiveNumber = val =>
  isNumber(val)
    ? clamp(val, 0, Number.MAX_VALUE)
    : 0;

export default parsePositiveNumber;
